import { render } from "./ScrollToTop.vue?vue&type=template&id=576fae5d&ts=true"
import script from "./ScrollToTop.vue?vue&type=script&lang=ts"
export * from "./ScrollToTop.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__